import { render, staticRenderFns } from "./addPolicyList.vue?vue&type=template&id=9b01f38c&scoped=true&"
import script from "./addPolicyList.vue?vue&type=script&lang=js&"
export * from "./addPolicyList.vue?vue&type=script&lang=js&"
import style0 from "./addPolicyList.vue?vue&type=style&index=0&id=9b01f38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b01f38c",
  null
  
)

export default component.exports